import { thunkProgress } from 'redux-progress';
import type { Dispatch, GetState } from 'model/State';
import {
  isBtfAlreadyUsedForCMT,
  manageAppLinkForBtfUnderCmt,
  siteNameWithDomainForBtfUnderCmt,
} from '../../api';
import {
  IS_BTF_ALREADY_USED_FOR_CMT,
  MANAGE_APP_LINK_FOR_BTF_UNDER_CMT,
  SITE_NAME_WITH_DOMAIN_FOR_BTF_UNDER_CMT,
} from './types';
import { selectAccountId } from '../accountId';

export const fetchIsBtfAlreadyUsedForCMT = () => (dispatch: Dispatch, getState: GetState) => {
  const state = getState();
  const accountId = selectAccountId(state) || '';

  dispatch(
    thunkProgress(IS_BTF_ALREADY_USED_FOR_CMT, isBtfAlreadyUsedForCMT(accountId, getState())),
  );
};

export const fetchManageAppLinkForBtfUnderCmt = () => (dispatch: Dispatch, getState: GetState) => {
  const state = getState();
  const accountId = selectAccountId(state) || '';

  dispatch(
    thunkProgress(
      MANAGE_APP_LINK_FOR_BTF_UNDER_CMT,
      manageAppLinkForBtfUnderCmt(accountId, getState()),
    ),
  );
};

export const fetchSiteNameWithDomainForBtfUnderCmt =
  () => (dispatch: Dispatch, getState: GetState) => {
    const state = getState();
    const accountId = selectAccountId(state) || '';

    dispatch(
      thunkProgress(
        SITE_NAME_WITH_DOMAIN_FOR_BTF_UNDER_CMT,
        siteNameWithDomainForBtfUnderCmt(accountId, getState()),
      ),
    );
  };
